
const Constans = {
    timeZoneOffset: 3,
    approximateAnalyzeTime: 300,
    freeAdditionalTrial: 10,
    reanalyzeAvailableInDays: 1,
    invoiceStatuses: {
        new: 0,
        success: 3,
    },
    spySubscriptionStatuses: {
        NEW: 0,
        ACTIVE: 1,
        PROCESS: 2,
        ERROR: 3,
        CANCELED: 5,
    },
    typeHeaders: {
        POST: 'newItemPublishedLabel',
        LIKE: 'newLikeLabel',
        COMMENT: 'newCommentLabel',
    },
    reviews: {
        'en-US': [
            {
                up: 421,
                down: 9,
                text: 'Even though I am well aware it is unfair, I made the decision to use this program to get the whole story. My husband is chatting with with someone on Instagram, and I can\'t live in suspense. It\'s still not too late; I want to know what\'s happening! 😿 I sincerely hope in DataJam...',
                photo: '/spy20-lk/img/subscription-page/reviews/user-avatar-0.svg',
                name: 'Anonymous',
            },
            {
                up: 369,
                down: 3,
                text: 'I requested assistance being unable to finish the service\'s payment process. The guys answered right away! They clarified the issue for me and showed me how to work with my bank to resolve it. The promptness of the answer and the high level of the guys\' work astounded me. I advise everyone to use the service! 👍🤩',
                photo: '/spy20-lk/img/subscription-page/reviews/user-avatar-1.png',
                name: 'James D',
            },
            {
                up: 557,
                down: 6,
                text: 'I\'ll be honest; I had no idea how to solve that problem. My son began using Instagram far too frequently. And I can tell that he is becoming quite tense and nervous; he can\'t stand to be without a phone for even a few minutes. I can use DataJam to figure out why I can\'t just leave things as they are 🙏',
                photo: '/spy20-lk/img/subscription-page/reviews/user-avatar-2.png',
                name: 'Alex',
            },
            {
                up: 236,
                down: 1,
                text: 'I started receiving friend requests from untargeted accounts once my Instagram profile was promoted. I was curious about their activities and how they learned about me. This service was suggested by a friend. The results I got from this service were fantastic, despite the low fee! I was pleasantly delighted, and I will tell my friends about it! 😌',
                photo: '/spy20-lk/img/subscription-page/reviews/user-avatar-3.png',
                name: 'Juan Sews',
            },
        ],
        'ru-RU': [
            {
                up: 421,
                down: 9,
                text: 'Я знаю, что так поступать нечестно, но я решила узнать правду через эту программу. Мой муж общается с кем-то в Instagram, и я не могу жить в неизвестности. Я хочу выяснить, что происходит, чтобы не было слишком поздно! 😿 Очень надеюсь на Инсташпиона...',
                photo: '/spy20-lk/img/subscription-page/reviews/user-avatar-0.svg',
                name: 'Аноним',
            },
            {
                up: 369,
                down: 3,
                text: 'Я не смог завершить процесс оплаты на сервисе и попросил помощи. Ребята ответили сразу же! Они объяснили мне, в чем проблема и как решить ее с моим банком. Удивлен скоростью ответа и качеством работы ребят, всем рекомендую сервис! 👍🤩',
                photo: '/spy20-lk/img/subscription-page/reviews/user-avatar-1.png',
                name: 'Олег К',
            },
            {
                up: 557,
                down: 6,
                text: 'Честно говоря, я не знала, как решить мою проблему. Мой ребенок стал слишком часто пользоваться Instagram. И я вижу, что он стал очень нервным и дерганым, ни минуты не может просидеть без телефона. Инсташпион поможет выяснить причину, не могу оставить все как есть 🙏',
                photo: '/spy20-lk/img/subscription-page/reviews/user-avatar-2.png',
                name: 'Александра',
            },
            {
                up: 236,
                down: 1,
                text: 'После раскрутки моего профиля инстаграм ко мне стали проситься в друзья нецелевые аккаунты. Мне стало интересно, как они узнали обо мне и какая у них активность. Знакомая порекомендовала этот продукт. Цена на это приложение небольшая, но результаты, которые я получила, великолепны! Я была приятно удивлена, буду рекомендовать друзьям! 😌',
                photo: '/spy20-lk/img/subscription-page/reviews/user-avatar-3.png',
                name: 'Жанна Савельева',
            },
        ],
    },
};

export { Constans };